<template>
  <div class="page-header d-flex align-items-center mt-3 mb-3">
  <DevHeader />
    <div
      v-if="!!enableBackLink && !specialBackLink"
      class="header-wrapper flex-fill"
    >
      <a class="back-link" @click="$router.go(-1)">
        <div class="d-flex" style="cursor: pointer">
          <b-col class="pr-2 pl-0 pt-1 vertical-center">
            <i class="fas fa-arrow-left"></i>
          </b-col>
          <b-col class="flex-fill vertical-center pr-1 pl-1 pt-1">
            <div class="header-title">{{ title }}</div>
          </b-col>
        </div>
      </a>
    </div>
    <div
      v-if="!!enableBackLink && !!specialBackLink"
      class="header-wrapper flex-fill"
    >
      <a class="back-link" @click="$emit('goBack')">
        <div class="d-flex" style="cursor: pointer">
          <b-col class="pr-2 pl-0 pt-1 vertical-center">
            <i class="fas fa-arrow-left"></i>
          </b-col>
          <b-col class="flex-fill vertical-center pr-1 pl-1 pt-1">
            <div class="header-title">{{ title }}</div>
          </b-col>
        </div>
      </a>
    </div>
    <div
      v-if="!!headerLink && !enableBackLink"
      class="header-wrapper flex-fill"
    >
      <router-link :to="headerLink" class="w-100">
        <div
          v-if="headerIcon"
          class="d-flex align-items-center"
        >
          <div class="w-100">
            <div class="header-title vertical-center d-flex w-75">
              <div class="link-text text-dots mr-2">{{ title }}</div>
              <div class="horizontal-center">
                <i class="custom-header-icon" :class="headerIcon"></i>
              </div>
            </div>
          </div>
        </div>
        <div v-else class="vertical-center">
          <div class="header-title">
            {{ title }}
          </div>
        </div>
      </router-link>
    </div>
    <div v-else class="header-wrapper flex-fill">
      <div v-if="!enableBackLink" class="vertical-center">
        <div class="header-title">{{ title }}</div>
      </div>
    </div>

    <div class="header-buttons d-flex font-poppins">

      <div class="exit-button ml-2 d-flex">
        <div @click="logout" class="d-flex align-items-center">
          <div class="pt-1" style="font-size: 14px !important;">
            <i class="fas fa-person-from-portal"></i>
          </div>
        </div>
      </div>
    </div>
    <OfflineOverlay />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DevHeader from "@/components/DevHeader.vue";
import OfflineOverlay from "@/components/OfflineOverlay.vue";

export default {
  name: "PageHeader",
  components: {DevHeader, OfflineOverlay},
  props: {
    title: {
      type: String,
    },
    headerLink: {
      type: String,
    },
    enableBackLink: {
      type: Boolean,
      default: false,
    },
    specialBackLink: {
      type: Boolean,
      default: false,
    },
    headerIcon: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      stripeOptionsStatus: null,
      statusColor: null,
      statusIcon: null,
      statusLink: null,
      taskNumber: 0,
    };
  },
  methods: {
    getUrlWithHttp(url) {
      if (url.includes("http")) {
        return url;
      } else {
        return "http://" + url;
      }
    },

    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },

    logout() {
      let self = this;
      self.$store.dispatch("login/logout");
      document.title = self.$cte("profile.loginDocTitle");      
      window.localStorage.clear();
      localStorage.removeItem('vuex');
      self.$router.push("/login");
      window.localStorage.clear();
    },
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
};
</script>

<style lang="scss" scoped>
.page-header {
  width: 100%;
  max-width: 100%;
  margin-bottom: 20px;
}

.header-title {
  font-family: "Jumper";
  //text-transform: uppercase;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.header-wrapper {
  overflow: auto;

  a {
    color: #000000 !important;
    font-weight: 600;
  }

  a:hover {
    text-decoration: none;
    color: #B2EC5D !important;
  }

  .back-link {
    font-size: 1.5rem;
  }
}

.header-buttons {
  .header-button {
    cursor: pointer;
    color: #252734;
    background-color: #AEBFC7;
    border-radius: 32px;
    box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.10);

    a {
      color: #000000 !important;
      font-weight: 600;
    }

    a:hover {
      color: #B2EC5D !important;
    }

    &-text {
      @media (min-width: 768px) {
        margin-left: 3px;
      }
    }

    &-icon {
      line-height: 1.5rem;

      @media (min-width: 768px) {
        margin: 0 3px;
      }

      .status-icon {
        line-height: 1.5rem;
        font-size: 1.5rem;
      }

      img {
        width: 1.5rem;
        height: 1.5rem;
      }

    }
  }

  .header-button:hover, .header-button-icon:hover {
    color: #B2EC5D !important;
  }
}

.task-counter {
  background-color: #F88379;
  color: #ffffff;
  border-radius: 32px;
  padding-top: 4px;
  padding-left: 1px;
  font-size: 10px;
  width: 20px;
  height: 20px;
}

.exit-button {
  cursor: pointer;
  color: #252734;
  background-color: #AEBFC7;
  border-radius: 32px;
  box-shadow: 0px 20px 30px rgba(0, 0, 0, 0.10);
  width: 40px;
  height: 40px;
  padding-left: 13px;
}

.exit-button:hover {
  color: #B2EC5D !important;
}

@media (max-width: 768px) {
  .task-counter-container {
    background-color: #F88379 !important;
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
}
</style>
